export const BILLING_CYCLE_TEXT = {
  monthly: 1,
  annual: 2
};

export default BILLING_CYCLE_TEXT;
